import { render } from "./insure-team-company.vue?vue&type=template&id=6faf7cf0&scoped=true&ts=true"
import script from "./insure-team-company.vue?vue&type=script&lang=ts"
export * from "./insure-team-company.vue?vue&type=script&lang=ts"

import "./insure-team-company.vue?vue&type=style&index=0&id=6faf7cf0&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faf7cf0"]])

export default __exports__